import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Leaf, Pencil } from "lucide-react";

export default function About() {
  const { user } = useAuth();
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content/about").then(({ data }) => setContent(data));
  }, []);

  return (
    <div className="k-container py-16 md:py-24">
      <div className="mx-auto max-w-3xl">
        <div className="flex items-center justify-between">
          <span className="k-tag" data-testid="about-tag">
            <Leaf className="mr-2 h-3.5 w-3.5" /> Hakkımızda
          </span>
          {user?.role === "admin" && (
            <Link to="/admin/hakkimizda" className="k-btn-ghost text-sm text-sage-700" data-testid="admin-edit-about-link">
              <Pencil className="mr-1 h-4 w-4" /> Düzenle
            </Link>
          )}
        </div>

        {!content ? (
          <div className="mt-8 h-96 animate-pulse rounded-3xl bg-cream-200/50" />
        ) : (
          <>
            <h1
              className="mt-6 font-display text-6xl text-ink-900 md:text-7xl"
              data-testid="about-title"
            >
              {content.title}
            </h1>

            <div
              className="k-prose mt-10"
              data-testid="about-body"
              dangerouslySetInnerHTML={{ __html: content.body }}
            />

            <div className="mt-14 rounded-[2rem_1rem_2rem_1rem] border border-sage-500/30 bg-sage-500/10 p-8 text-center md:p-12">
              <p className="font-display text-4xl text-ink-900 md:text-5xl" data-testid="about-closing">
                Artık bu yolda beraberiz.
                <br />
                Kabile'ne hoş geldin.
              </p>
              {!user && (
                <div className="mt-8 flex flex-wrap justify-center gap-3">
                  <Link to="/register" className="k-btn-primary" data-testid="about-cta-register">
                    Kabileye katıl
                  </Link>
                  <Link to="/login" className="k-btn-secondary" data-testid="about-cta-login">
                    Giriş yap
                  </Link>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
